import React, {PureComponent} from 'react';
import $ from 'jquery';
import Alert from 'react-s-alert';
import {Modal} from 'react-responsive-modal';
import ReactTooltip from 'react-tooltip';

import {withTranslation} from 'react-i18next';
import {withCookies} from 'react-cookie';

const telemetryIP = process.env.REACT_APP_TELEMETRY_IP;
const messagePort = process.env.REACT_APP_MESSAGE_PORT;

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

const super_admin = parseInt(process.env.REACT_APP_SUPER_ADMIN_ID);
const admin = parseInt(process.env.REACT_APP_EVENT_ADMIN_ID);
const sub_admin = parseInt(process.env.REACT_APP_EVENT_SUB_ADMIN_ID);

const MiniPitStopSessionTypeID = 7;

class CarTables extends PureComponent {

    constructor(props) {
        super(props);
        this.closeNav = this.closeNav.bind(this);
    }

    closeNav() {
        this.props.toggleSidebar((toggleCarList) => {
            if (!toggleCarList) {
                document.getElementById("myNav").style.width = "0%";
            }
        });
    }

    render() {
        return (
            <div id={$(window).width() > 1200 ? "mySidebar" : "myNav"} className={$(window).width() > 1200 ? "sidebar" : "overlay"}>
                {$(window).width() <= 1200 ? (
                    <div style={{display: "inline-block", marginBottom: 40}}>
                        <span className={"closebtn"} style={{zIndex: 100}} onClick={this.closeNav}>&times;</span>
                    </div>
                ) : null}
                <div className={$(window).width() > 1200 ? "" : "overlay-content"}>
                    <div className={"col-sm-12"} style={{padding: 5}}>
                        <TopTable
                            carList={this.props.carList}
                            isGuest={this.props.isGuest}
                            carID={this.props.carID}
                            updateCurrentCarID={this.props.updateCurrentCarID}
                            sessionID={this.props.sessionID}
                            eventID={this.props.eventID}
                            userID={this.props.userID}
                            sessionTypeID={this.props.sessionTypeID}
                            privileges={this.props.privileges}
                            t={this.props.t}
                            cookies={this.props.cookies}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

class TopTable extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            searchVehicle: "",
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeVehicleSearch = this.handleChangeVehicleSearch.bind(this);
        this.popoutLiveTiming = this.popoutLiveTiming.bind(this);
        this.popoutMiniChallenge = this.popoutMiniChallenge.bind(this);
        this.popoutMiniChallengeLive = this.popoutMiniChallengeLive.bind(this);
        this.registerStartFuel = this.registerStartFuel.bind(this);
        this.registerEndFuel = this.registerEndFuel.bind(this);
        this.handleShowCarStateModal = this.handleShowCarStateModal.bind(this);
        this.handleCloseCarStateModal = this.handleCloseCarStateModal.bind(this);
        this.changeVehicleStatus = this.changeVehicleStatus.bind(this);
    }

    handleChange(e) {
        const parts = e.split("_");
        this.props.updateCurrentCarID(parseInt(parts[0]), parseInt(parts[1]), parts[2]);
    }

    handleChangeVehicleSearch(e) {
        e.preventDefault();
        if (!isNaN(e.target.value)) {
            let number = e.target.value;
            this.setState({
                searchVehicle: number,
            });
        }
    }

    handleShowCarStateModal(e) {
        e.preventDefault();
        e.stopPropagation();
        let vehicle = null;

        // Search vehicle in list
        for (let i = 0; i < this.props.carList.length; i++) {
            if (parseInt(e.target.value) === this.props.carList[i].id) {
                vehicle = this.props.carList[i];
                break;
            }
        }

        // Check if vehicle was actually found
        if (vehicle === null || vehicle.data === undefined) {
            return false;
        }

        // Act according state
        let statusText = "";
        switch (vehicle.data.rsi) {
            case (0): {
                statusText = this.props.t("finished").toUpperCase();
                break;
            }
            case (1): {
                statusText = this.props.t("racing").toUpperCase();
                break;
            }
            case (2): {
                statusText = this.props.t("dns").toUpperCase();
                break;
            }
            case (3): {
                statusText = this.props.t("dnf").toUpperCase();
                break;
            }
            default: {
                statusText = "---";
                break;
            }
        }

        // Build modal body
        let modalBody = (
            <div className={"container-fluid"}>
                <div className={"row"}>
                    <p className={"col-xs-12 App_smallHeader"} style={{color: "#000000", whiteSpace: "normal"}}>{this.props.t("changeStatusMsg_1")} <b>{statusText}</b><br/> {this.props.t("changeStatusMsg_2")}</p>
                </div>
                {vehicle.data.rsi === 0 ? (
                    <div/>
                ) : (
                    <div className={"col-xs-12 col-sm-4"} style={{padding: 2}}>
                        <button
                            style={{background: "#ff0003", fontWeight: "bold"}}
                            type={"button"}
                            className={"btn btn-block App_white_text_liveMaxes button"}
                            value={0}
                            onClick={() => {
                                this.changeVehicleStatus(vehicle.id, 0);
                            }}
                        >
                            {this.props.t("finished").toUpperCase()}
                        </button>
                    </div>
                )}
                {vehicle.data.rsi === 1 ? (
                    <div/>
                ) : (
                    <div className={"col-xs-12 col-sm-4"} style={{padding: 2}}>
                        <button
                            style={{background: "#ff0003", fontWeight: "bold"}}
                            type={"button"}
                            className={"btn btn-block App_white_text_liveMaxes button"}
                            value={1}
                            onClick={() => {
                                this.changeVehicleStatus(vehicle.id, 1);
                            }}
                        >
                            {this.props.t("racing").toUpperCase()}
                        </button>
                    </div>
                )}
                {vehicle.data.rsi === 2 ? (
                    <div/>
                ) : (
                    <div className={"col-xs-12 col-sm-4"} style={{padding: 2}}>
                        <button
                            style={{background: "#ff0003", fontWeight: "bold"}}
                            type={"button"}
                            className={"btn btn-block App_white_text_liveMaxes button"}
                            value={2}
                            onClick={() => {
                                this.changeVehicleStatus(vehicle.id, 2);
                            }}
                        >
                            {this.props.t("dnf").toUpperCase()}
                        </button>
                    </div>
                )}
                {vehicle.data.rsi === 3 ? (
                    <div/>
                ) : (
                    <div className={"col-xs-12 col-sm-4"} style={{padding: 2}}>
                        <button
                            style={{background: "#ff0003", fontWeight: "bold"}}
                            type={"button"}
                            className={"btn btn-block App_white_text_liveMaxes button"}
                            value={3}
                            onClick={() => {
                                this.changeVehicleStatus(vehicle.id, 3);
                            }}
                        >
                            {this.props.t("dns").toUpperCase()}
                        </button>
                    </div>
                )}
            </div>
        );

        this.setState({
            showRetireModal: true,
            modalData: modalBody,
        });
    }

    handleCloseCarStateModal() {
        this.setState({
            showRetireModal: false,
            handleConfirmRetireCar: -1,
        });
    }

    changeVehicleStatus(carID, newStatus) {
        const helper = this;

        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/changeVehicleStatus',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.sessionID,
                carID: carID,
                newStatus: newStatus,
            },
            success: function (data) {
                helper.handleCloseCarStateModal();
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("changeStatusSuccess") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                helper.handleCloseCarStateModal();
                Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("changeStatusError") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }
        });
    }

    popoutLiveTiming(e) {
        e.preventDefault();
        window.open(
            "/liveTiming/" + this.props.eventID + "/" + this.props.sessionID + "/" + this.props.userID,
            'liveTiming',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=900"
        );
    }

    popoutMiniChallengeLive(e) {
        e.preventDefault();
        window.open(
            "/miniChallengeLive/" + this.props.eventID + "/" + this.props.sessionID + "/" + this.props.userID,
            'miniChallengeLive',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=900"
        );
    }

    popoutMiniChallenge(e) {
        e.preventDefault();
        window.open(
            "/miniChallengeZones/" + this.props.eventID + "/" + this.props.sessionID + "/" + this.props.carID + "/" + this.props.userID,
            'miniChallengeZones',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=900"
        );
    }

    registerStartFuel(e) {
        e.preventDefault();
        const helper = this;
        $.ajax({
            type: 'POST',
            url: telemetryIP + ':' + messagePort + '/command-worker-device?command=RT-ORG-SESSION-START-FUEL-REGISTRY&eventId=' + helper.props.eventID + '&sessionId=' + helper.props.sessionID,
            headers: {
                'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
            },
            dataType: 'json',
            success: function (data) {
                console.log('Successfully sent session final fuel registry request.');
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("setStartFuel") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error sending session final fuel registry request.');
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("somethingWentWrong") + '!</span>', {
                        position: 'top-right',
                        effect: 'genie',
                        beep: false,
                        timeout: 5000,
                        offset: 150
                    });
                }
            }
        });
    }

    registerEndFuel(e) {
        e.preventDefault();
        const helper = this;
        $.ajax({
            type: 'POST',
            url: telemetryIP + ':' + messagePort + '/command-worker-device?command=RT-ORG-SESSION-END-FUEL-REGISTRY&eventId=' + helper.props.eventID + '&sessionId=' + helper.props.sessionID,
            headers: {
                'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
            },
            dataType: 'json',
            success: function (data) {
                console.log('Successfully sent session final fuel registry request.');
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("setEndFuel") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error sending session final fuel registry request.');
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("somethingWentWrong") + '!</span>', {
                        position: 'top-right',
                        effect: 'genie',
                        beep: false,
                        timeout: 5000,
                        offset: 150
                    });
                }
            }
        });
    }

    render() {
        return (
            <>
                <Modal open={this.state.showRetireModal}
                       onClose={this.handleCloseCarStateModal}
                       center={false}
                       classNames={{modal: "small-modal"}}
                       showCloseIcon={false}
                >
                    <div className={"modal-header"}>
                        <div className={"modal-title"}>
                            <b className={"App_header"} style={{color: "#000000"}}>{this.props.t("changeVehicleStatus")}</b>
                        </div>
                    </div>
                    <div className={"modal-body"}>
                        {this.state.modalData}
                        {this.state.waiting ? (
                            <div className={"alert alert-warning"} role={"alert"}>
                                {this.props.t("waitingForServer")}...
                            </div>
                        ) : (
                            <div/>
                        )}
                        {this.state.serverResult}
                    </div>
                    <div className={"modal-footer"}>
                        <button
                            onClick={this.handleCloseCarStateModal}
                            className={"btn App_header button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("close")}
                        </button>
                    </div>
                </Modal>
                <table className={"table table-condensed"}>
                    <thead>
                    <tr>
                        <th className={"App_driverListTitle"} colSpan={5}>
                            <div className={"row"} style={{paddingLeft: 10}}>
                                <div className={"col-xs-2"} style={{padding: 0}}>
                                    <input
                                        className={"form-control App_black_text"}
                                        style={{border: "2px solid #ed2126", height: 40}}
                                        value={this.state.searchVehicle}
                                        placeholder={"000"}
                                        type={"text"}
                                        onChange={this.handleChangeVehicleSearch}
                                    />
                                </div>
                                <div className={"col-xs-6 text-center"} style={{padding: 0}}>
                                    <span className={"App_small_title"}>
                                        {this.props.t("driversInSession").toUpperCase()}
                                    </span>
                                </div>
                                {(this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) ? (
                                    <div className={"col-xs-4"}>
                                        <button
                                            type={"button"}
                                            className={"btn btn-primary btn-block button App_small_white_text"}
                                            style={{float: "right"}}
                                            onClick={this.popoutLiveTiming}
                                        >
                                            {this.props.t("live").toUpperCase()} <i className={"far fa-clock"}/>
                                        </button>
                                    </div>
                                ) : (
                                    <div/>
                                )}
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th colSpan={5} style={{padding: 0}}>
                            {this.props.sessionTypeID === MiniPitStopSessionTypeID ? (
                                <div className={"col-xs-12"} style={{marginBottom: 5, padding: 0}}>
                                    <p className={"App_header"} style={{textAlign: "left", fontStyle: "italic"}}>MINI Pit Stop</p>
                                    {(this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) ? (
                                        <div>
                                            <button
                                                type={"button"}
                                                style={{margin: 2}}
                                                className={"btn btn-primary button col-xs-3"}
                                                onClick={this.registerStartFuel}
                                            >
                                                <i className={"fas fa-gas-pump"}/> {this.props.t("startFuel")}
                                            </button>
                                            <button
                                                type={"button"}
                                                style={{margin: 2}}
                                                className={"btn btn-primary button col-xs-3"}
                                                onClick={this.registerEndFuel}
                                            >
                                                <i className={"fas fa-gas-pump"}/> {this.props.t("endFuel")}
                                            </button>
                                        </div>
                                    ) : (
                                        <div/>
                                    )}
                                    <button
                                        type={"button"}
                                        style={{margin: 2}}
                                        className={"btn btn-primary button col-xs-2"}
                                        onClick={this.popoutMiniChallengeLive}
                                    >
                                        <i className={"fas fa-stopwatch"}/>{this.props.t("live")}
                                    </button>
                                    <button
                                        type={"button"}
                                        style={{margin: 2}}
                                        className={"btn btn-primary button col-xs-2"}
                                        onClick={this.popoutMiniChallenge}
                                        disabled={!this.props.carID}
                                    >
                                        <i className={"fas fa-search"}/>{this.props.t("zones")}
                                    </button>
                                </div>
                            ) : (
                                <div/>
                            )}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.props.carList.filter((car) => {
                        if (!isNaN(parseInt(this.state.searchVehicle))) {
                            if (("" + car.livery_number).indexOf(this.state.searchVehicle) !== -1) {
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            return true;
                        }
                    }).map((car) => {
                        let statusColor = "#000000";
                        let statusIcon = "";
                        let statusText = "---";
                        let statusOpacity = "1.0";

                        if (car.data) {
                            switch (car.data.rsi) {
                                case (0): {
                                    statusColor = "#000000";
                                    statusText = this.props.t("finished").toUpperCase();
                                    statusIcon = "fas fa-flag-checkered";
                                    statusOpacity = "1.0";
                                    break;
                                }
                                case (1): {
                                    statusColor = "#00802c";
                                    statusText = this.props.t("racing").toUpperCase();
                                    statusIcon = "fas fa-car-side";
                                    statusOpacity = "1.0";
                                    break;
                                }
                                case (2): {
                                    statusColor = "#be2000";
                                    statusText = this.props.t("dnf").toUpperCase();
                                    statusIcon = "fas fa-car-crash";
                                    statusOpacity = "0.6";
                                    break;
                                }
                                case (3): {
                                    statusColor = "#e09d00";
                                    statusText = this.props.t("dns").toUpperCase();
                                    statusIcon = "fas fa-hand-paper";
                                    statusOpacity = "0.6";
                                    break;
                                }
                                default: {
                                    statusColor = "#000000";
                                    statusText = "---";
                                    statusIcon = "";
                                    statusOpacity = "1.0";
                                    break;
                                }
                            }
                        }

                        let backgroundHighlight = "";
                        if (car.isOwnTeam === 1) {
                            backgroundHighlight = "#787878";
                        } else {
                            backgroundHighlight = "none";
                        }

                        return (
                            <tr
                                key={car.id + "_" + car.isOwnTeam}
                                style={{background: backgroundHighlight, cursor: "pointer", opacity: statusOpacity}}
                                onClick={() => this.handleChange(car.id + "_" + car.isOwnTeam + "_" + car.speedSource)}
                                className={"onHover"}
                            >
                                <td style={{valign: "center"}}>
                                    <input type={"radio"}
                                           onChange={() => this.handleChange(car.id + "_" + car.isOwnTeam + "_" + car.speedSource)}
                                           name={"optradio"}
                                           className={"form-radio"}
                                           checked={(parseInt(this.props.carID) === parseInt(car.id))}
                                    />
                                </td>
                                <td className={"App_cellText_teamNumber"}>
                                    #{car.livery_number}
                                </td>

                                <td className={"App_cellText_teamName"}>{(car.short_name && car.short_name.length > 0 ? car.short_name : car.team_name.substr(0, 6))}</td>
                                <td className={"App_cellText_gap"} id={"list_gap_" + car.id}>
                                    {car.gap}
                                </td>
                                {this.props.isGuest ? null : (
                                    <td style={{width: "1%"}}>
                                        <button
                                            data-tip={true}
                                            data-for={"car_status_" + car.id}
                                            style={{background: statusColor, fontWeight: "bold"}}
                                            type={"button"}
                                            className={"btn btn-block button"}
                                            value={car.id}
                                            onClick={((this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) ? this.handleShowCarStateModal : () => {
                                            })}
                                        >
                                            <i className={statusIcon} style={{color: "#ffffff"}}/>
                                        </button>
                                        <ReactTooltip id={"car_status_" + car.id} type={"light"}>
                                            <span className={"App_title"}>{statusText}</span>
                                        </ReactTooltip>
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </>
        );
    }
}

export default withTranslation("translations")(withCookies(CarTables));
